import { IZoomOverlaySpec } from 'phoenix2/components/widgets/zoom-overlay';

export const UPDATE_APPSTATE = 'UPDATE_APPSTATE';
export const SET_CURRENT_APP = 'SET_CURRENT_APP';
export const TOGGLE_HANDS_UP = 'TOGGLE_HANDS_UP';
export const TOGGLE_LOCKED = 'TOGGLE_LOCKED';
export const SET_FREE_GAMES = 'SET_FREE_GAMES';
export const SET_ACTIVITY_RESTORE_INFO = 'SET_ACTIVITY_RESTORE_INFO';
export const SET_ETAG = 'SET_ETAG';
export const SET_KEYBOARD_HANDLER_ID = 'SET_KEYBOARD_HANDLER_ID';
export const SET_ASSETS_SERVER = 'SET_ASSETS_SERVER';
export const ASSETS_TOKEN_EXPIRED = 'ASSET_TOKEN_EXPIRED';
export const SET_IMAGE_ZOOM = 'SET_IMAGE_ZOOM';
export const UPDATE_IMAGE_ZOOM = 'UPDATE_IMAGE_ZOOM';
export const SET_ZOOM_OVERLAY = 'SET_ZOOM_OVERLAY';
export const UPDATE_ZOOM_OVERLAY = 'UPDATE_ZOOM_OVERLAY';
export const SET_POP_LAST_VIEW_URL = 'SET_POP_LAST_VIEW_URL';
export const DISABLE_TABLES_GAMES_TIMER = 'DISABLE_TABLES_GAMES_TIMER';

export function updateAppState(key: any, value: any) {
    return { type: UPDATE_APPSTATE, key, value };
}

export function setCurrentApp(app: any) {
    return { type: SET_CURRENT_APP, app };
}

export function toggleHandsUp(status: any) {
    return { type: TOGGLE_HANDS_UP, status };
}

export function toggleLocked(status: any, timestamp: any) {
    return { type: TOGGLE_LOCKED, status, timestamp };
}

export function setFreeGames(freeGames: any) {
    return { type: SET_FREE_GAMES, freeGames };
}

export function setActivityRestoreInfo(activityRestoreInfo: any) {
    return { type: SET_ACTIVITY_RESTORE_INFO, activityRestoreInfo };
}

export function setDisableTablesGamesTimer(disableTablesGamesTimer: any) {
    return { type: DISABLE_TABLES_GAMES_TIMER, disableTablesGamesTimer };
}

// NOTE: We still need this as discoveryweb uses the asset token to talk to speechserver. It's not used for assets anymore.
export function setAssetsServer(server: any) {
    return { type: SET_ASSETS_SERVER, server };
}

// NOTE: We still need this as discoveryweb uses the asset token to talk to speechserver. It's not used for assets anymore.
export function assetsTokenExpired() {
    return { type: ASSETS_TOKEN_EXPIRED };
}

/**
 * Sets the Etag of the bundle.
 * @param etag the JavaScript file's etag
 */
export function setEtag(etag: any) {
    return { type: SET_ETAG, etag };
}

export function setKeyboardHandlerId(id: any) {
    return { type: SET_KEYBOARD_HANDLER_ID, id };
}

/**
 * Activates/deactivates the image zooming full-screen overlay
 * @param zoomSpec an object containing details for the image zooming. Matches
 * the following type:
 *
 * interface IZoomSpec {
 *   // Url for the image to zoom.
 *   src?: string;
 *   // If src is not provided, the ID of an asset from the content to display
 *   assetId?: string;
 *   // Array of objects containing assetId and onSelect keys
 *   additionalImages?: Array<any>
 *   // When we have additional images, which index are we currently viewing
 *   startIndex?: number
 * }
 */
export function setImageZoom(zoomSpec: any) {
    return { type: SET_IMAGE_ZOOM, zoomSpec };
}

export function updateImageZoom(zoomSpec: any) {
    return { type: UPDATE_IMAGE_ZOOM, zoomSpec };
}

/**
 * Activates/deactivates the image zooming full-screen overlay which supports all types of elements
 * instead of just images.
 * In the future it could replace the ImageZooming overlay as well.
 */
export function setZoomOverlay(zoomSpec: IZoomOverlaySpec | null) {
    return { type: SET_ZOOM_OVERLAY, zoomSpec };
}

export function updateZoomOverlay(zoomSpec: Partial<IZoomOverlaySpec>) {
    return { type: UPDATE_ZOOM_OVERLAY, zoomSpec };
}

/**
 * Sets a url to go to if the user pops the last view (used in the New User app,
 * which should go back to Sparx Web)
 * @param url
 */
export function setPopLastViewURL(url: any) {
    return { type: SET_POP_LAST_VIEW_URL, url };
}
